<template>
    <div id="promotion-list" class="data-list-container vs-con-loading__container">
        <vs-table mutiple :max-items="itemsPerPage" :data="promosList">
       <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <vs-button type="border" class="mb-6 gradient gradient-primary no-shadow" icon-pack="feather" icon="icon-plus" @click="addNewData">Add New</vs-button>
        <!-- <vs-popup fullscreen title="ADD NEW PROMOTION" :active.sync="popupActive">

        </vs-popup> -->
       </div>
      <template slot="thead">
        <vs-th class="text-center">Num</vs-th>
        <vs-th class="center-title">Promotion</vs-th>
        <vs-th class="center-title p-0">Delivered & Redemp</vs-th>
        <vs-th class="center-title p-0">Income & Expense</vs-th>
        <vs-th class="center-title">Date Sent</vs-th>
        <vs-th></vs-th>
      </template>
      <template slot-scope="{data}">
        <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" class="shadow-md">
              <vs-td>
                <p class="product-name font-medium truncate text-center">{{ indextr + 1 }}</p>
              </vs-td>
              <vs-td>
                <p class="group-list promotion-type font-medium p-0" style="color:cornflowerblue">
                  <span style="color:cornflowerblue" v-for="(gr,index) in test(tr)" :key="index"> {{gr}}</span>
                </p>
                <p class="product-name font-medium truncate">{{ tr.campaign.name }}</p>
                Discount:
                <div v-if="tr.campaign.logic_type=='percent'">
                  <p class="product-name font-medium truncate"><b class="logic-font-size">{{ tr.campaign.logic_value }}%</b></p>
                </div>
                 <div v-else-if="tr.campaign.logic_type=='usd'">
                  <p class="product-name font-medium truncate"><b class="logic-font-size">{{ tr.campaign.logic_value }}$</b></p>
                </div>
                <div v-else>
                  <p class="product-name font-medium truncate"><b class="logic-font-size">N/A</b></p>
                </div>
                <vs-row class="flex">
                  <feather-icon icon="CalendarIcon" svgClasses="w-4 h-4 stroke-current" ></feather-icon>
                  <span class="product-name font-medium truncate" style="padding-top:5px;padding-left:5px;">{{ changeFormat1(tr.campaign.start_date)}} to {{changeFormat1(tr.campaign.expired_date)}}</span>
                </vs-row>
              </vs-td>
              <vs-td>
                <!-- <vs-row>
                   <vs-col vs-w="6">
                     <span class="text-uppercase">RECEIVED MESSAGES</span>
                     <p class="promotion-type font-medium truncate">{{ tr.campaign_report.total_receive_message }}</p>
                   </vs-col>
                   <vs-col vs-w="6">
                     <span class="text-uppercase">REDEMPTION</span>
                     <p class="promotion-type font-medium truncate">{{ tr.campaign_report.total_redemption }}</p>
                   </vs-col>
                </vs-row> -->
                <vs-row>
                  <vs-col class="px-2" vs-w="6"><span class="text-uppercase custom-font-size-title">TOTAL DELIVERED</span></vs-col>
                  <vs-col class="px-2" vs-w="6"><span class="text-uppercase custom-font-size-title">REDEMPTION</span></vs-col>
                </vs-row>
                <vs-row>
                  <vs-col class="px-2" vs-w="6"><p class="promotion-type font-medium truncate text-center">{{ tr.campaign_report.total_receive_message }}</p></vs-col>
                  <vs-col class="px-2" vs-w="6"><p class="promotion-type font-medium truncate text-center">{{ tr.campaign_report.total_redemption }}</p></vs-col>
                </vs-row>
              </vs-td>
              <vs-td>
                <vs-row>
                  <vs-col vs-w="12" class="flex flex-col align-center">
                    <span class="text-uppercase custom-font-size-title m-0">INCOME</span>
                    <p class="product-name font-medium truncate text-center">${{ tr.campaign_report.total_income }}</p>
                    <span class="text-uppercase custom-font-size-title m-0 mt-5">EXPENSE</span>
                    <p class="product-name font-medium truncate text-center">${{ tr.campaign_report.total_expense }}</p>
                  </vs-col>
                  <!-- <vs-col vs-w="4"> -->
                    <!-- <p class="text-center" style="line-height:120px;">{{tr.campaign_report.claim_percent}}%</p> -->
                  <!-- </vs-col> -->
                </vs-row>
              </vs-td>

              <vs-td>
                <div v-if="tr.sent_at != null">
                  <p class="product-name font-medium truncate text-center">{{ changeFormat1(tr.campaign.sent_at) }}</p>
                  <p class="product-name font-medium truncate text-center">{{ getTime(tr.campaign.sent_at) }}</p>
                </div>
                <div v-else>
                  <p class="product-name font-medium truncate text-center">{{ changeFormat1(tr.campaign.created_at) }}</p>
                  <p class="product-name font-medium truncate text-center">{{ getTime(tr.campaign.created_at) }}</p>
                </div>
              </vs-td>

              <vs-td class="pl-0">
                <router-link :to="{path: 'promotion/promotion-detail?id=' + tr.campaign.id, params: {promotionInfo: tr}}" :key="tr.id"><vs-button class="p-3 text-sm gradient gradient-primary no-shadow">See Detail</vs-button></router-link>
              </vs-td>
            </vs-tr>
          </tbody>
      </template>
    </vs-table>
    <div v-if="promosData._meta.pageCount">
      <!-- <vs-pagination class="mt-6 custom-pagination" :total="parseInt(promosData._meta.pageCount)" v-model="currentPage" @click.native="changePage(currentPage, itemsPerPage)"></vs-pagination> -->
      <custom-pagination class="custom-pagination mt-6" :totalPages="parseInt(promosData._meta.pageCount)"
            :currentPage="currentPage" @pageChanged="changePage" :key="page_key"></custom-pagination>
    </div>

    <vs-add-promotion :currentPage="currentPage" :itemsPerPage="itemsPerPage" :addPromoConfig="addPromoConfig" :sidebarData="sidebarData" :groupsList="groupsList" @AddPromotion="addPromotion" @CloseAddPromo="closeAddPromo" :key="abc"></vs-add-promotion>
    </div>
</template>

<script>
    import moment from 'moment';
    import {changeFormatHelper, changeFormatWithDateTime} from '../../helper/datetimeHelper';
    export default {
        name: 'vs-promotion-list',
        components:{
            moment
        },
        // props: {
        //   dataChange: {
        //     type: Object
        //   }
        // },
        data() {
            return {
                popupActive: false,
                selected: [],
                promotionInfo :{},

                // itemsPerPage: 4,
                isMounted: false,

                // Data Sidebar
                sidebarData: {

                },
                sidebarConfig: {
                    isOpen: false
                },
                addPromoConfig:{
                    isOpen: false,
                    requireOptOut: false,
                },
                abc :0,
                group_name:'',
                currentPage: 1,
                itemsPerPage: 5,
                action_type: '',
                isOpenLoading: false,
                page_key: 0,
                loaded_data_num: 0
            }
        },
        computed: {
            promosData(){
            return this.$store.state.promoList.promoData;
            },
            promosList(){
            return this.$store.state.promoList.promoList;
            },
            groupsList(){
            // console.log(this.$store.state.promoList.groupList)
            return this.$store.state.promoList.groupList;
            },
            // currentPage() {
            //   if(this.isMounted) {
            //     return this.$refs.table.currentx
            //   }
            //   return 0
            // },

        },
        watch:{
          active: function () {
            document.body.style.overflow = this.active ? 'hidden' : ''
          },
          // dataChange: {
          //   immediate: true,
          //   deep: true,
          //   handler: function () {
          //     // if(this.dataChange) {
          //     //   console.log(this.dataChange.message);
          //     // }
          //     // if(this.dataChange && this.dataChange.message == 'afterInsert') {
          //     if(this.dataChange) {
          //       const obj = {
          //         page: this.currentPage,
          //         "per-page": this.itemsPerPage,
          //       }
          //       this.$store.dispatch("promoList/GET_PROMO_LIST", obj)
          //     }
          //   },
          // }
          loaded_data_num: {
            immediate: true,
            handler() {
              if(this.loaded_data_num >= 2) {
                this.closeLoading();
              } else {
                this.action_type = "Get data";
                this.openLoadingInDiv();
              }
            }
          }
        },
        methods:{
            openLoadingInDiv(){
              this.$vs.loading({
                container: '#app',
                scale: 0.8
              })
              // setTimeout( ()=> {
              //   this.$vs.loading.close('#staff-list > .con-vs-loading')
              // }, 500);
              if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
              }
              this.isOpenLoading = true;
              this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                  this.closeLoading();
                  // this.$vs.notify({
                  //   title:'Notification',
                  //   text: this.action_type + ' promotion failed',
                  //   color:'danger',
                  //   position:'top-right'})
                  this.$vs.dialog({
                    color: 'danger',
                    title: 'Notification',
                    text: this.action_type + ' promotion failed',
                    acceptText: 'OK'
                  })
                }
              }, 10000);

            },
            closeLoading() {
              this.$vs.loading.close('#app > .con-vs-loading');
              this.isOpenLoading = false;
            },
            test(tr){
            let arr = tr.campaign.groups.split(',');
            let temp = [];
            for(let i=0;i<this.groupsList.length;i++){
                for(let j = 0; j < arr.length; j++) {
                if(arr[j] == this.groupsList[i].id){
                    if(temp.length > 0) {
                    temp.push(',')
                    }
                    temp.push(this.groupsList[i].name)
                }
                }
            }
            return temp;
            },
            changePage(currentPage) {
                const obj = {
                    page: currentPage,
                    "per-page": this.itemsPerPage,
                }
                this.action_type = 'Get list';
                if(!this.isOpenLoading) {
                  this.openLoadingInDiv();
                }
                this.$store.dispatch("promoList/GET_PROMO_LIST", obj).then(() => {
                  this.closeLoading();
                  this.page_key++;
                  this.currentPage = currentPage;
                })
            },
            changeFormat(date){
              if(date) {
                return changeFormatWithDateTime(date);
              } else {
                return 'N/A';
              }
            },
            changeFormat1(date){
              if(date) {
                return changeFormatHelper(date);
              } else {
                return 'N/A';
              }
            },
            getTime(date) {
              if(date) {
                return moment(date).format('hh:mm A');
              } else {
                return '';
              }
            },
            addPromotion(data){
              this.abc++;
              this.action_type = 'Add';
              if(!this.isOpenLoading) {
                this.openLoadingInDiv();
              }
              return this.$store.dispatch("promoList/ADD_PROMOTION" ,data).then(() => {
                  this.closeLoading();
                  this.$vs.notify({
                    title:'Notification',
                    text:'Add Promotion Success',
                    color:'success',
                    position:'top-right'})
                }).catch((err) => {
                  this.closeLoading();
                  if(err && (err == "Sms count is not enough" || err == "Sms count is not enough!" || err.toLowerCase().includes("sms count is not enough"))) {
                    this.$vs.dialog({
                      color: 'warning',
                      title: '⚠ Notification',
                      text: ' Your SMS balance is not sufficient to send promotion. Please contact us to recharge a new SMS package.',
                      acceptText: 'OK',
                      type: 'alert'
                    })
                  } else {
                    this.$vs.notify({
                      title:'Fail',
                      text: err,
                      color:'danger',
                      position:'top-right'
                    })
                  }
                })
            },
            addNewData() {
              // document.body.style.overflow = 'hidden';
              if(!this.isOpenLoading) {
                this.openLoadingInDiv();
              }
              this.action_type = 'Check limit';
              this.$store.dispatch("promoList/CHECK_LIMIT_PROMOTION").then(() => {
                this.$store.dispatch("promoList/CHECK_OPT_OUT_REQUIRED").then(()=>{
                  this.closeLoading();
                  this.abc++;
                  this.sidebarData = {}
                  this.addPromoConfig.requireOptOut = false;
                  this.addPromoConfig.isOpen = true;
                }).catch(()=>{
                  this.closeLoading();
                  this.abc++;
                  this.sidebarData = {}
                  this.addPromoConfig.requireOptOut = true;
                  this.addPromoConfig.isOpen = true;
                });
              }).catch((err) => {
                this.closeLoading();
                this.$vs.dialog({
                  color: 'danger',
                  title: 'Notification',
                  text: err,
                  acceptText: 'OK'
                })
              })
              // this.abc++;
              // this.sidebarData = {}
              // this.addPromoConfig.isOpen = true;
            },
            closeAddPromo(){
            this.addPromoConfig.isOpen = false;
            document.getElementById("promotion-list").click();
            }
        },
        created() {
            // this.promosList = this.$store.getters['promoList/promoList'];
            const obj = {
            page: this.currentPage,
            "per-page": this.itemsPerPage
            }
            this.$store.dispatch("promoList/GET_PROMO_LIST", obj).then(() => {
              this.loaded_data_num++;
            })
            this.$store.dispatch("promoList/GET_GROUP_LIST", obj).then(() => {
              this.loaded_data_num++;
            })
        },
        mounted() {
            this.isMounted = true;
        }
    }
</script>
